import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  computed,
  input,
  output,
  signal,
} from '@angular/core';
import { SvgComponent } from '../svg/svg.component';
import { AsyncPipe, CommonModule } from '@angular/common';
import { ButtonType } from '@core/models';
import { TranslatePipe, SentenceBreakPipe } from '@core/pipes';
import { ButtonComponent } from '../button/button.component';

export enum StatusMessageType {
  Success = 'success',
  Error = 'error',
  Info = 'info',
}

@Component({
  selector: 'sc-status-message-widget',
  imports: [
    SvgComponent,
    CommonModule,
    AsyncPipe,
    TranslatePipe,
    ButtonComponent,
    SentenceBreakPipe,
  ],
  templateUrl: './status-message-widget.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusMessageWidgetComponent {
  public closed = output();
  public title = input<string>('');
  public subtitle = input<string>('');
  public isCrossBtnHidden = input<boolean>(false);
  public type = input<StatusMessageType>(StatusMessageType.Info);

  public isVisible = signal<boolean>(true);

  public ButtonType = ButtonType;
  public StatusMessageType = StatusMessageType;

  constructor(private cdr: ChangeDetectorRef) {}

  get widgetTitle() {
    if (this.title()) {
      return this.title();
    }

    switch (this.type()) {
      case StatusMessageType.Success:
        return 'shared.successMessage';
      case StatusMessageType.Error:
        return 'shared.errorMessage';
      default:
        return 'shared.informationalMessage';
    }
  }

  public closeInfoBlock() {
    this.isVisible.set(false);
    this.closed.emit();
    this.cdr.markForCheck();
  }
}
